// extracted by mini-css-extract-plugin
export default {"inputGroup":"AddText_inputGroup__RYzBe"};